/**
 * PuzzleDatabase - Machine-verified chess puzzles
 * Mined from randomized games and verified with Stockfish 16:
 * every line is a forced mate, and for mate-in-2/3 puzzles the key move is unique.
 * line[0], line[2], ... are the player's moves; line[1], line[3], ... are the
 * opponent's scripted replies (best defense).
 */

import { ChessPuzzle } from '../../types';

export class PuzzleDatabase {
  private static readonly puzzles: ChessPuzzle[] = [
    {
      id: 'mined_001',
      fen: '3Nk2r/4p3/B6n/pp1p3p/3PpB2/P3K1Pb/1Pr5/RN5R b k - 1 19',
      line: [{ from: 'h6', to: 'f5' }],
      rating: 850,
      themes: ['checkmate', 'mate_in_1'],
      description: 'Black to move: mate in 1',
    },
    {
      id: 'mined_002',
      fen: '3k3r/4p3/B6n/pp1p3p/3PpB2/P3K1PR/1Pr5/RN6 b - - 0 20',
      line: [{ from: 'h6', to: 'f5' }],
      rating: 890,
      themes: ['checkmate', 'mate_in_1'],
      description: 'Black to move: mate in 1',
    },
    {
      id: 'mined_003',
      fen: '3k3r/4p3/B6n/pp1p3p/3PpB2/P3K1P1/1r5R/RN6 b - - 1 21',
      line: [{ from: 'h6', to: 'f5' }],
      rating: 930,
      themes: ['checkmate', 'mate_in_1'],
      description: 'Black to move: mate in 1',
    },
    {
      id: 'mined_004',
      fen: 'r1bqk1nr/p1pp1p1p/n7/2b1N1p1/6P1/1Q6/PP1PPP1P/R1B1KBNR w KQkq - 1 7',
      line: [{ from: 'b3', to: 'f7' }],
      rating: 970,
      themes: ['checkmate', 'mate_in_1'],
      description: 'White to move: mate in 1',
    },
    {
      id: 'mined_005',
      fen: 'r1bqk1nr/p1pp1p1p/n2b4/4N1p1/6P1/1Q1P4/PP2PP1P/R1B1KBNR w KQkq - 1 8',
      line: [{ from: 'b3', to: 'f7' }],
      rating: 1010,
      themes: ['checkmate', 'mate_in_1'],
      description: 'White to move: mate in 1',
    },
    {
      id: 'mined_006',
      fen: 'r1bq1k1r/p1pp1p2/n2b3p/6B1/6N1/2QP4/PP2PP1P/1R2KBNR w K - 0 12',
      line: [{ from: 'c3', to: 'h8' }],
      rating: 1050,
      themes: ['checkmate', 'mate_in_1'],
      description: 'White to move: mate in 1',
    },
    {
      id: 'mined_007',
      fen: 'r1bq1k1r/p2p1p2/n2b3p/2p3B1/6N1/2QP3N/PP2PP1P/1R2KB1R w K - 0 13',
      line: [{ from: 'c3', to: 'h8' }],
      rating: 1250,
      themes: ['checkmate', 'mate_in_1'],
      description: 'White to move: mate in 1',
    },
    {
      id: 'mined_008',
      fen: 'rn2kb1r/2R1ppp1/p6p/1p6/PP2bPn1/6P1/2PQP2P/1NB1KBNR w Kkq - 1 11',
      line: [{ from: 'c7', to: 'c8' }],
      rating: 1290,
      themes: ['checkmate', 'mate_in_1'],
      description: 'White to move: mate in 1',
    },
    {
      id: 'mined_009',
      fen: '1n2kb1r/r1R1ppp1/p6p/1p6/PP2bPn1/6P1/2PQP2P/1NBK1BNR w k - 3 12',
      line: [{ from: 'c7', to: 'c8' }],
      rating: 1330,
      themes: ['checkmate', 'mate_in_1'],
      description: 'White to move: mate in 1',
    },
    {
      id: 'mined_010',
      fen: '1n2kbr1/r1R1ppp1/p6p/Pp6/1P2bPn1/6P1/2PQP2P/1NBK1BNR w - - 1 13',
      line: [{ from: 'c7', to: 'c8' }],
      rating: 1370,
      themes: ['checkmate', 'mate_in_1'],
      description: 'White to move: mate in 1',
    },
    {
      id: 'mined_011',
      fen: 'rn1qkb1r/p1ppp1p1/3Q4/1p3n1p/1P5P/P3p3/2P1K1P1/RN3BNR w kq - 2 15',
      line: [{ from: 'd6', to: 'g6' }],
      rating: 1410,
      themes: ['checkmate', 'mate_in_1'],
      description: 'White to move: mate in 1',
    },
    {
      id: 'mined_012',
      fen: '2b3nr/3p1kb1/q3pp1p/6pN/PP1n4/N1P1PPP1/3P3P/R1B1K2R b KQ - 6 16',
      line: [{ from: 'a6', to: 'e2' }],
      rating: 1450,
      themes: ['checkmate', 'mate_in_1'],
      description: 'Black to move: mate in 1',
    },
    {
      id: 'mined_013',
      fen: 'r1b1k1nr/1p1p3p/6p1/p7/2P3p1/b2N3P/4PPP1/q1B1KB1R b Kkq - 0 14',
      line: [{ from: 'a3', to: 'b4' }, { from: 'd3', to: 'b4' }, { from: 'a1', to: 'c1' }],
      rating: 1450,
      themes: ['checkmate', 'mate_in_2'],
      description: 'Black to move: mate in 2',
    },
    {
      id: 'mined_014',
      fen: 'r1n1k3/p2qppr1/3p2p1/1Pp3P1/1P6/P2P1NPR/3K1P2/RN3Q2 w q - 2 20',
      line: [{ from: 'h3', to: 'h8' }, { from: 'g7', to: 'g8' }, { from: 'h8', to: 'g8' }],
      rating: 1490,
      themes: ['checkmate', 'mate_in_2'],
      description: 'White to move: mate in 2',
    },
    {
      id: 'mined_015',
      fen: '6nr/r1ppkp1p/4p1p1/p1P1N3/3PP3/6PP/1q3Q2/2B1KB1R w K - 3 18',
      line: [{ from: 'f2', to: 'f7' }, { from: 'e7', to: 'd8' }, { from: 'f7', to: 'd7' }],
      rating: 1530,
      themes: ['checkmate', 'mate_in_2'],
      description: 'White to move: mate in 2',
    },
    {
      id: 'mined_016',
      fen: 'rnb1kb1r/1Qpp3p/4pqp1/8/P7/8/1PPP2PP/R1B1KBNn b Qkq - 0 9',
      line: [{ from: 'f6', to: 'f2' }, { from: 'e1', to: 'd1' }, { from: 'f2', to: 'f1' }],
      rating: 1700,
      themes: ['checkmate', 'mate_in_2'],
      description: 'Black to move: mate in 2',
    },
    {
      id: 'mined_017',
      fen: '1k3r2/4p2p/7b/1N4p1/3pP3/1P4PN/2Q1BP1P/2B2K1R w - - 1 20',
      line: [{ from: 'c2', to: 'c7' }, { from: 'b8', to: 'a8' }, { from: 'c7', to: 'a7' }],
      rating: 1740,
      themes: ['checkmate', 'mate_in_2'],
      description: 'White to move: mate in 2',
    },
    {
      id: 'mined_018',
      fen: '1k1r4/4p2p/7b/1N4p1/3pP3/1P3BPN/2Q2P1P/2B2K1R w - - 3 21',
      line: [{ from: 'c2', to: 'c7' }, { from: 'b8', to: 'a8' }, { from: 'c7', to: 'a7' }],
      rating: 1780,
      themes: ['checkmate', 'mate_in_2'],
      description: 'White to move: mate in 2',
    },
    {
      id: 'mined_019',
      fen: 'rnbq2nr/p1pppkbp/1p3P2/8/5NQ1/2P5/PP1P1PPP/R1B1KBNR w KQ - 1 9',
      line: [{ from: 'g4', to: 'g7' }, { from: 'f7', to: 'e8' }, { from: 'f6', to: 'f7' }],
      rating: 1820,
      themes: ['checkmate', 'mate_in_2'],
      description: 'White to move: mate in 2',
    },
    {
      id: 'mined_020',
      fen: 'rn4nr/1b1B1kbp/1p6/p3p3/6Q1/1Pq3P1/P2PNP1P/R1B1K2R w KQ - 1 16',
      line: [{ from: 'g4', to: 'e6' }, { from: 'f7', to: 'f8' }, { from: 'e6', to: 'e8' }],
      rating: 1860,
      themes: ['checkmate', 'mate_in_2'],
      description: 'White to move: mate in 2',
    },
    {
      id: 'mined_021',
      fen: '2rqkbn1/pp1bp1pr/8/2P4p/1n2p2N/N1P5/PP3PPP/R1BK1BR1 b - - 2 12',
      line: [{ from: 'd7', to: 'g4' }, { from: 'd1', to: 'e1' }, { from: 'd8', to: 'd1' }],
      rating: 1900,
      themes: ['checkmate', 'mate_in_2'],
      description: 'Black to move: mate in 2',
    },
    {
      id: 'mined_022',
      fen: '2bqkb1r/r4n1p/pppn4/5p2/1P1p1P2/P6P/2PNP1P1/R1BQKB1R b Kk - 1 16',
      line: [{ from: 'd8', to: 'h4' }, { from: 'g2', to: 'g3' }, { from: 'h4', to: 'g3' }],
      rating: 1940,
      themes: ['checkmate', 'mate_in_2'],
      description: 'Black to move: mate in 2',
    },
    {
      id: 'mined_023',
      fen: '2bqkb1r/r4n1p/ppp5/5p2/1Pnp1P2/P6P/2PNP1P1/1RBQKB1R b Kk - 3 17',
      line: [{ from: 'd8', to: 'h4' }, { from: 'g2', to: 'g3' }, { from: 'h4', to: 'g3' }],
      rating: 2050,
      themes: ['checkmate', 'mate_in_2'],
      description: 'Black to move: mate in 2',
    },
    {
      id: 'mined_024',
      fen: 'r1bqkbnr/p1ppp1p1/7p/2n2P2/5P2/8/PP1NB2P/R1BQK1NR w KQkq - 1 10',
      line: [{ from: 'e2', to: 'h5' }, { from: 'g7', to: 'g6' }, { from: 'h5', to: 'g6' }],
      rating: 2090,
      themes: ['checkmate', 'mate_in_2'],
      description: 'White to move: mate in 2',
    },
    {
      id: 'mined_025',
      fen: 'r2qkbn1/p1ppp1p1/b4P2/2n4r/5P2/8/PP1N3P/R1BQK1NR w KQq - 0 13',
      line: [{ from: 'd1', to: 'h5' }, { from: 'g7', to: 'g6' }, { from: 'h5', to: 'g6' }],
      rating: 2130,
      themes: ['checkmate', 'mate_in_2'],
      description: 'White to move: mate in 2',
    },
    {
      id: 'mined_026',
      fen: '4kb1r/4pp1p/2p2np1/8/1p5q/NP2BQ2/2P5/6K1 w k - 0 23',
      line: [{ from: 'f3', to: 'c6' }, { from: 'f6', to: 'd7' }, { from: 'c6', to: 'c8' }],
      rating: 2170,
      themes: ['checkmate', 'mate_in_2'],
      description: 'White to move: mate in 2',
    },
    {
      id: 'mined_027',
      fen: 'rbbB1k1r/p7/n1Q2N1p/3p4/8/3P3N/PP2PP1P/1R2KB1R w K - 0 17',
      line: [{ from: 'c6', to: 'e8' }, { from: 'f8', to: 'g7' }, { from: 'f6', to: 'h5' }, { from: 'g7', to: 'h7' }, { from: 'e8', to: 'f7' }],
      rating: 2150,
      themes: ['checkmate', 'mate_in_3'],
      description: 'White to move: mate in 3',
    },
    {
      id: 'mined_028',
      fen: '5k2/r2n1p1r/p1pp2p1/6b1/P3P3/1q6/6P1/N2RK1N1 b - - 1 22',
      line: [{ from: 'b3', to: 'e3' }, { from: 'e1', to: 'f1' }, { from: 'h7', to: 'h1' }, { from: 'g2', to: 'g3' }, { from: 'h1', to: 'g1' }],
      rating: 2190,
      themes: ['checkmate', 'mate_in_3'],
      description: 'Black to move: mate in 3',
    },
    {
      id: 'mined_029',
      fen: '3qkb2/1bp1p3/8/1pn5/1P6/P1P5/3N4/RK5n b - - 0 23',
      line: [{ from: 'd8', to: 'd2' }, { from: 'a1', to: 'a2' }, { from: 'd2', to: 'd1' }, { from: 'b1', to: 'b2' }, { from: 'c5', to: 'a4' }],
      rating: 2230,
      themes: ['checkmate', 'mate_in_3'],
      description: 'Black to move: mate in 3',
    },
    {
      id: 'mined_030',
      fen: '4k1nr/p1Q2ppp/bp2p3/3p4/P7/b3P3/1BPP1PPP/1N2KBNR w Kk - 1 10',
      line: [{ from: 'b2', to: 'a3' }, { from: 'd5', to: 'd4' }, { from: 'f1', to: 'b5' }, { from: 'a6', to: 'b5' }, { from: 'c7', to: 'c8' }],
      rating: 2270,
      themes: ['checkmate', 'mate_in_3'],
      description: 'White to move: mate in 3',
    },
    {
      id: 'mined_031',
      fen: 'rnb2bn1/1p1pp1k1/5p2/p7/5Bp1/1P4PR/PR6/3Q1KN1 w - - 1 21',
      line: [{ from: 'd1', to: 'g4' }, { from: 'g7', to: 'f7' }, { from: 'g4', to: 'h5' }, { from: 'f7', to: 'e6' }, { from: 'b2', to: 'e2' }],
      rating: 2310,
      themes: ['checkmate', 'mate_in_3'],
      description: 'White to move: mate in 3',
    },
    {
      id: 'mined_032',
      fen: 'rnbq2nr/p1pp1kbp/1p3P2/1B2p3/5NQ1/2P5/PP1P1PPP/R1B1K1NR w KQ - 0 10',
      line: [{ from: 'g4', to: 'g7' }, { from: 'f7', to: 'e8' }, { from: 'f6', to: 'f7' }, { from: 'e8', to: 'e7' }, { from: 'f7', to: 'f8', promotion: 'q' }],
      rating: 2450,
      themes: ['checkmate', 'mate_in_3'],
      description: 'White to move: mate in 3',
    },
    {
      id: 'mined_033',
      fen: 'r1bqkbnr/p1ppp1p1/8/2n2P1p/5P2/5B2/PP1N3P/R1BQK1NR w KQkq - 0 11',
      line: [{ from: 'f3', to: 'h5' }, { from: 'h8', to: 'h5' }, { from: 'd1', to: 'h5' }, { from: 'g7', to: 'g6' }, { from: 'h5', to: 'g6' }],
      rating: 2490,
      themes: ['checkmate', 'mate_in_3'],
      description: 'White to move: mate in 3',
    },
    {
      id: 'mined_034',
      fen: 'r2qkbnr/p1ppp1p1/b4P2/2n4p/5P2/5B2/PP1N3P/R1BQK1NR w KQkq - 1 12',
      line: [{ from: 'f3', to: 'h5' }, { from: 'h8', to: 'h5' }, { from: 'd1', to: 'h5' }, { from: 'g7', to: 'g6' }, { from: 'h5', to: 'g6' }],
      rating: 2530,
      themes: ['checkmate', 'mate_in_3'],
      description: 'White to move: mate in 3',
    },
    {
      id: 'mined_035',
      fen: 'r1bqkb1r/pppp1pp1/2n1p2p/8/NP2PP2/8/P1PPN1Bn/R1BQK2R b KQq - 2 9',
      line: [{ from: 'd8', to: 'h4' }, { from: 'e2', to: 'g3' }, { from: 'h4', to: 'g3' }, { from: 'e1', to: 'e2' }, { from: 'c6', to: 'd4' }],
      rating: 2570,
      themes: ['checkmate', 'mate_in_3'],
      description: 'Black to move: mate in 3',
    },
    {
      id: 'mined_036',
      fen: 'k4bnr/4pp1p/p3Q3/4Pp2/8/3P3N/1P1KP2P/2B2B1R w - - 2 20',
      line: [{ from: 'e6', to: 'c8' }, { from: 'a8', to: 'a7' }, { from: 'c8', to: 'c7' }, { from: 'a7', to: 'a8' }, { from: 'f1', to: 'g2' }],
      rating: 2610,
      themes: ['checkmate', 'mate_in_3'],
      description: 'White to move: mate in 3',
    },
  ];

  /**
   * Get a random puzzle
   */
  static getRandomPuzzle(): ChessPuzzle {
    const index = Math.floor(Math.random() * this.puzzles.length);
    return this.puzzles[index];
  }

  /**
   * Get a puzzle by difficulty rating range
   */
  static getPuzzleByDifficulty(minRating: number, maxRating: number): ChessPuzzle {
    const filtered = this.puzzles.filter(p => p.rating >= minRating && p.rating <= maxRating);
    if (filtered.length === 0) {
      return this.getRandomPuzzle();
    }
    const index = Math.floor(Math.random() * filtered.length);
    return filtered[index];
  }

  /**
   * Get puzzle by difficulty tier
   */
  static getPuzzleByTier(tier: 'beginner' | 'easy' | 'medium' | 'hard' | 'expert'): ChessPuzzle {
    const ranges: Record<typeof tier, [number, number]> = {
      beginner: [800, 1200],
      easy: [1200, 1600],
      medium: [1600, 2000],
      hard: [2000, 2400],
      expert: [2400, 3000]
    };
    const [min, max] = ranges[tier];
    return this.getPuzzleByDifficulty(min, max);
  }

  static getAllPuzzles(): ChessPuzzle[] {
    return this.puzzles;
  }
}
